import {
    NonVerifiedUserAccount,
    UserAccount,
    VerifiedUserAccount,
    VerifyRequestResponse,
} from "./interfaces"

export function createVerifiedUserAccount(data: VerifyRequestResponse): VerifiedUserAccount {
    return {
        kind: "verified",
        ...data,
    }
}

export function createNonVerifiedUserAccount(): NonVerifiedUserAccount {
    return {
        kind: "nonVerified",
        allowed_referral_program: false,
        allowed_deposit_purchase: false,
        telegram_account: null,
        psychologists: [],
        completed_surveys: 0,
        is_hr: false,
        is_b2b: false,
    }
}

export function isVerified(data: UserAccount): data is VerifiedUserAccount {
    return data.kind === "verified"
}
